import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-icon-tiktok',
  shadow: false,
})
export class CmsIconTiktok {
  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';
  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  render() {
    return (
      /*@ts-ignore*/
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 20 21"
        focusable="false"
        aria-hidden="true"
        fill-rule="evenodd"
        clip-rule="evenodd"
        width={this.dataWidth}
        height={this.dataHeight}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 8.44163C17.2306 8.44586 15.5046 7.89371 14.0658 6.86317V14.0505C14.0654 15.3816 13.6587 16.6809 12.9004 17.7746C12.142 18.8683 11.068 19.7043 9.82199 20.1707C8.576 20.6371 7.21739 20.7118 5.92784 20.3847C4.63828 20.0577 3.47925 19.3445 2.60571 18.3405C1.73218 17.3365 1.18578 16.0896 1.03958 14.7665C0.893376 13.4434 1.15434 12.1071 1.78758 10.9365C2.42082 9.76577 3.39615 8.81642 4.58315 8.21537C5.77015 7.61431 7.11224 7.39019 8.42997 7.57298V11.1879C7.82698 10.9982 7.17947 11.0039 6.57991 11.2043C5.98036 11.4047 5.45942 11.7895 5.09148 12.3039C4.72355 12.8182 4.52745 13.4357 4.53117 14.0682C4.53489 14.7007 4.73826 15.3159 5.11222 15.8259C5.48618 16.3358 6.01161 16.7145 6.61348 16.9078C7.21536 17.1011 7.86289 17.0992 8.46361 16.9023C9.06433 16.7055 9.58752 16.3237 9.95846 15.8115C10.3294 15.2994 10.5291 14.683 10.5291 14.0505V0H14.0658C14.0634 0.298857 14.0884 0.597307 14.1406 0.891577V0.891577C14.2635 1.54849 14.519 2.17341 14.8916 2.72811C15.2641 3.28281 15.7458 3.75564 16.3073 4.11766C17.106 4.64613 18.0424 4.9278 19 4.9276V8.44163Z"
          fill={this.dataFill}
        />
      </svg>
    );
  }
}
